<template>
  <div class="button-container" index="1">
    <div
      v-if="val >= -1" 
      class="number-container" 
      :class="
        (posFocus + 1 == val || (posFocus == 9 && val == 0))
          ? {'background-button-focus' : val >= 0 }
          : {'background-button' : val >= 0 }
      "
      :id="val <= -1 ? 'empty-box' : ''"
      @click="addNumber" 
    >
      <div class="hover-cover"></div>
      <div class="number">
        {{ val >= 0 ? val : '' }}
      </div>   
    </div>
  </div>
</template>

<script>
  import { soundList, soundPlayer } from '../utils/sounds';

  export default {
    props: {
      val: {
        type: Number,
      },
      posFocus: {
        type: Number,
      },
    },
    methods: {
      addNumber() {
        if (this.val >= 0) {
          soundPlayer(soundList.general);
          this.$emit('add_number', this.val);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .button-container {
    display: flex;
    flex: 1;
    max-width: 33%;
    min-width: 33%;
    width: 33%;

    &::before {
      content: '';
      padding-top: 100%;
    }

    .number-container {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      flex: 1;
      height: 85%;
      margin: auto;
      max-height: 85%;
      max-width: 85%;
      position: relative;
      overflow: hidden;
      min-height: 60px;

      @media (max-width: 768px) {
        width: 55px;
        height: 60px;
        min-height: unset;
      }

      @media (max-height: 480px) {
        max-width: 45px;
        height: 45px;
        min-height: unset;
      }

      @media (max-height: 290px) {
        height: 35px;
        max-width: 35px;
      }

      .hover-cover {
        margin: 3px;
        width: 94%;
        height: 94%;
        border-radius: 50%;
        background-color: #ffa726;
        position: absolute;
        display: none;

        @media (max-height: 480px) {
          width: 100%;
          height: 100%;
        }
      }

      &:hover,
      &:focus {
        .hover-cover {
          display: block;
        }

        .number {
          z-index: 9999;
          color: #fff;
        }
      }

      &#empty-box {
        cursor: unset;

        .hover-cover {
          background: transparent;
        }
      }
    }

    .background-button {
      background-color: #fff;
      border: 4px solid #fff;
      border-radius: 50%;
      box-shadow: inset 0px 0px 0px 4px #6d4c41;

      @media (max-width: 425px) {
        width: 45px;
        height: 45px;
        max-width: 45px;
        margin-bottom: 5px;
        box-shadow: inset 0px 0px 0px 2px #6d4c41;
        border: 3px solid #fff;
      }

      @media (max-height: 480px) {
        margin-bottom: 5px;
        box-shadow: inset 0px 0px 0px 2px #fff;
        border: 2px solid #6d4c41;
      }
    }

    .background-button-focus {
      background-color: #ffa726;
      border: 4px solid #fff;
      border-radius: 50%;
      box-shadow: inset 0px 0px 0px 4px #6d4c41;

      .hover-cover {
        display: block;
      }
    }

    .number {
      display: inline-block;
      color: #6d4c41;
      font-family: 'Nunito-ExtraBold', serif;
      flex: 1;
      font-size: 26px;
      margin: auto;
      max-width: 85%;
      max-height: 85%;
      text-align: center;
      
      @media (min-width: 1090px) {
        font-size: 3em;
      }

      @media (max-height: 480px) {
        font-size: 24px;
      }

      @media (max-height: 275px) {
        font-size: 22px;
      }
    }
  }
</style>